/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ToolCheckoutInfo } from '../../models/tool-checkout-info';

export interface GetToolCheckoutInfo$Params {
  productionOrderId: number;
}

export function getToolCheckoutInfo(http: HttpClient, rootUrl: string, params: GetToolCheckoutInfo$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ToolCheckoutInfo>>> {
  const rb = new RequestBuilder(rootUrl, getToolCheckoutInfo.PATH, 'get');
  if (params) {
    rb.path('productionOrderId', params.productionOrderId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ToolCheckoutInfo>>;
    })
  );
}

getToolCheckoutInfo.PATH = '/api/v1/Tool/{productionOrderId}/GetToolCheckoutInfo';
